import React from 'react';
import Brand from '../Image/Brand/Brand';
import Pill from '../Pill/Pill';
import Span from '../Texts/Span/Span';
import * as S from './ItemEstablishment.styles';

const images = {
  VISA: 'visa_color',
  'VISA DEBITO': 'visa_debito_color',
  MASTERCARD: 'mastercard_color',
  'MASTERCARD DEBITO': 'mastercard_debito_color',
  CABAL: 'cabal_color',
  'CABAL DEBITO': 'cabal_debito_color',
  'UNION PAY': 'unionpay_color',
  MAESTRO: 'maestro_color',
  AMEX: 'amex_color',
  DISCOVER: 'discover_color',
  DEFAULT: 'none_color',
  PRIVADA: 'none_color',
};

const ItemEstablishment = ({
  brand,
  sale_method,
  establishment_id,
  fantasy_name,
  business_area,
  bank,
}) => (
  <S.ItemEstablishment>
    <S.Info>
      <S.BrandWrapper>
        <Brand name={images[brand] || 'none_color'} width={48} height={32} />
      </S.BrandWrapper>
      <Pill variant='neutral-1'>{sale_method.toLowerCase()}</Pill>
    </S.Info>
    <S.Detail>
      <S.FirstContent>
        <Span type='1' variant='neutral' modifier='strong'>
          {establishment_id}
        </Span>
        <Span type='2' variant='neutral'>
          {fantasy_name}
        </Span>
      </S.FirstContent>
      <S.SecondContent>
        <Span type='4' variant='neutral' modifier='strong'>
          {business_area}
        </Span>
        <Span type='5' variant='neutral'>
          {bank}
        </Span>
      </S.SecondContent>
    </S.Detail>
  </S.ItemEstablishment>
);

export default ItemEstablishment;
